import React,{useEffect,useState} from 'react'
import {Link} from 'react-router-dom'
import axios from 'axios'
import _ from 'lodash'
import { ToastContainer, toast } from 'react-toastify';
import { BASE_URL } from '../Config/Base';
import Success from '../Assets/Images/oatsuccessgif.gif'
import Error from '../Assets/Images/ErrorOatGif.gif'
const pageSize = 5;

const Oataddusermain = () => {


//  var UserId= localStorage.getItem('UserId')

// GET request using fetch()

const token = JSON.parse(localStorage.getItem('usertoken'));
const [allusers, setAllusers] = useState([])


const [paginatedPosts, setpaginatedPosts] = useState();
const [currentPage, setcurrentPage] = useState(1);
const[Roletable, setRoletable] =useState([])   


useEffect(()=>{  
  
  getUsers()




}, [])


  function getUsers(){

    
    console.log("Token", token)
  fetch(`${BASE_URL}/Oat/Getoatusers`, {

    method: 'GET',

    headers: {

      "Content-type": "application/json",

      "Accept": "application/json",

      "Authorization": "Bearer " + `${token}`,

      "Access-Control-Allow-Headers": "Access-Control-Request-Headers "

    },

    //body:JSON.stringify(data)

  }).then(response => response.json())

    .then(data => {
      console.log("Data", data);
      setAllusers(data);
      setpaginatedPosts(_(data).slice(0).take(pageSize).value());
        }
    );

console.log("check",allusers)


      }

      const pageCount = allusers? Math.ceil(allusers.length/pageSize) :0;
      // if (pageCount === 1)
      // return null;
      
      const pages = _.range(1, pageCount+1)
      
      const pagination =(pageNo)=>{
      setcurrentPage(pageNo);
      const startIndex = (pageNo - 1) * pageSize;
      const paginatedPost = _(allusers).slice(startIndex).take(pageSize).value();
      setpaginatedPosts(paginatedPost)
      }
      const onNext = () => {


        pagination(currentPage + 1);
      };
    
      const onPrevious = () => {
        pagination(currentPage - 1);
      };
  
/*---Get Roles ----*/


function getRole(){


  fetch(`${BASE_URL}/Oat/GetOatRole`, {
    method:'GET',

  headers : {

    "Content-type": "application/json",

    "Accept": "application/json",

    "Authorization": "Bearer " +`${token}`,

    "Access-Control-Allow-Headers": "Access-Control-Request-Headers "
  },


})

        .then(response => response.json())


          .then(data => {
           console.log("Role",data)
           setRoletable(data)
            localStorage.setItem("Data", JSON.stringify(data));
          });
         }
//function fetch

function fetchdata() 
  {
    
    let data = {
      username:document.getElementById('username').value,
      email:document.getElementById('email').value,
      password:document.getElementById('password').value,
      role:document.getElementById('roleid').value,
      ventureid:'03',
      active:1,
      deleteStatus:0,
      assignStatus:1,
      roleid:'02',
      ventureName:'OAT'
      
    }
   
    
    axios({

        method:"POST",
        url:`${BASE_URL}/Authenticate/REGISTER`,
        data,
        headers: {
          "Content-Type" : "application/json"
        }

    })
    .then((response) =>{
      console.log(response.data);
      
     
      if(response.data.status === "Success"){


        // toast.success("Registered Successfully !", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
          closeAddForm();
          document.getElementById("RegSuccess-Oat").style.display="block"
          getUsers();
          setcurrentPage(1)
          setTimeout(() => {
            document.getElementById("RegSuccess-Oat").style.display="none"
           
          }, 2000);
         
          
       }
       else if(response.data.message === "Username Already Exist"){
        // toast.error("Username Already Exist", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        document.getElementById("NameExist-Oat").style.display="block"
       setTimeout(() => {
        document.getElementById("NameExist-Oat").style.display="none"
       
      }, 3000);
         
        

      }
      else if(response.data.message === "Email Already Exist"){
        // toast.error("Email Already Exist", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        document.getElementById("EmailExist-Oat").style.display="block"

        setTimeout(() => {
          document.getElementById("EmailExist-Oat").style.display="none"
         
        }, 3000);
        
      }
   
     
    })
.catch(error => {
  console.log(error);
  alert("User creation failed !")
    
 
})
  }

// validation

function handleSubmit(event){

  event.preventDefault();
  var name = document.getElementById("username").value;
  var mail = document.getElementById("email").value;
  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var password = document.getElementById("password").value;
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 
  var role = document.getElementById("roleid").value;

  if(!name){
        
    document.getElementById("nameErr").innerHTML="Username Required";
  
   
  }
  else if(name.length<3)
  {
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
    
  }
  else{
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML=" ";
  }

  if(!mail){

    document.getElementById("mailErr").innerHTML="Email Required ";    
  }
  else if (email1.test(document.getElementById("email").value)===false){

    document.getElementById("mailErrA").innerHTML="Not Valid Email";
    document.getElementById("mailErr").innerHTML=" ";  
 }
  else{

    document.getElementById("mailErr").innerHTML="  ";  
    document.getElementById("mailErrA").innerHTML="  ";  

  }
  if(!password){
      
    document.getElementById("passErr").innerHTML="Password Required ";    

  }
  else if (password1.test(document.getElementById("password").value)===false){

    document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById("passErr").innerHTML=" ";  
 }
  else{

    document.getElementById("passErr").innerHTML="  ";  
    document.getElementById("passErrA").innerHTML="  ";  

  }
  if(!role){

    document.getElementById("roleErr").innerHTML="Role Required ";
  }
  else{

    document.getElementById("roleErr").innerHTML=" ";
  }
  if((name.length>=3) && (email1.test(document.getElementById("email").value)===true) && (password1.test(document.getElementById("password").value)===true) && role  ){
    
    fetchdata();
  }

}

function handlechange(){

  var name = document.getElementById("username").value;
  var mail = document.getElementById("email").value;
  const email1 = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  var password = document.getElementById("password").value;
  const password1 = /^(?=.*\d)(?=.*[!@#$%^&*])(?=.*[a-z])(?=.*[A-Z]).{8,}$/; 

  var role = document.getElementById("roleid").value;

  if(!name){
        
    document.getElementById("nameErr").innerHTML="Username Required";
    document.getElementById("nameErrA").innerHTML=" ";
   
  }
  else if(name.length<3)
  {
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML="Enter Atleast 3 Characters ";
    
  }
  else{
    document.getElementById("nameErr").innerHTML=" ";
    document.getElementById("nameErrA").innerHTML=" ";
  }

  if(!mail){

    document.getElementById("mailErr").innerHTML="Email Required ";
    document.getElementById("mailErrA").innerHTML="  ";      
  }
  else if (email1.test(document.getElementById("email").value)===false){

    document.getElementById("mailErrA").innerHTML="Not Valid Email";
    document.getElementById("mailErr").innerHTML=" ";  
 }
  else{

    document.getElementById("mailErr").innerHTML="  ";  
    document.getElementById("mailErrA").innerHTML="  ";  

  }
  if(!password){
      
    document.getElementById("passErr").innerHTML="Password Required ";
    document.getElementById("passErrA").innerHTML="  ";     

  }
  else if (password1.test(document.getElementById("password").value)===false){

    document.getElementById("passErrA").innerHTML="Please Enter atleast 8 characters one number,one Uppercase,one Lowercase and one Special Character";
    document.getElementById("passErr").innerHTML=" ";  
 }
  else{

    document.getElementById("passErr").innerHTML="  ";  
    document.getElementById("passErrA").innerHTML="  ";  

  }
  
  if(!role){

    document.getElementById("roleErr").innerHTML="Role Required ";
  }
  else{

    document.getElementById("roleErr").innerHTML=" ";
  }
}
// popup

    function openAddForm()
     {
       getRole()
	      document.getElementById("modalRegisterForm").style.display = "block";
      }

      
      function closeAddForm()
      {
        document.getElementById("nameErr").innerHTML=" ";
        document.getElementById("nameErrA").innerHTML=" ";
        document.getElementById("mailErr").innerHTML="  ";  
        document.getElementById("mailErrA").innerHTML="  ";  
        document.getElementById("passErr").innerHTML="  ";  
        document.getElementById("passErrA").innerHTML="  "; 
        document.getElementById("roleErr").innerHTML=" ";
       

        document.getElementById("oatform").reset();
         document.getElementById("modalRegisterForm").style.display = "none";
         
       }
       //password eyeicon
       function hide(){
         
        var x = document.getElementById("password");
        var eye = document.getElementById("eye");

        if(x.type === "password"){

          x.type = "text";
          eye.classList.remove("fa-eye-slash")
          eye.classList.add("fa-eye")
          
        }
        else{
          x.type = "password";
          eye.classList.remove("fa-eye")
          eye.classList.add("fa-eye-slash")
        }

       }

      //  ActiveStatus

       function ActiveStatus(Id){

   
        const body ={
         id: Id
       }
      
        console.log(body)
         axios({
        
         method:"POST",
        url:`${BASE_URL}/Oat/ActiveStatus`,
        data:body,
        headers: {
        "Content-Type" : "application/json",

        "Authorization": "Bearer " + `${token}`
     
        }
       
         })
         .then((response) =>{
         console.log(response.data);
          // setActive(response.data.active)

        //  if(active != 0) {
        //  toast.info("Activated"+" " + UserName +  "!", {
        //   position: "top-center",
        //   autoClose: 3200,
        //   hideProgressBar: false,
        //   closeOnClick: true,
        //   pauseOnHover: true,
        //   draggable: true,
        //   progress: undefined,
        //   className: 'toast-message'
        //   });
        //   setTimeout(() => {
        //     setcurrentPage(pageNo);
        //     getUsers();
        //   }, 1000);
        //  }

        //  else if(active == 0){
        //   toast.info("InActivated"+" " + UserName +  "!", {
        //     position: "top-center",
        //     autoClose: 3200,
        //     hideProgressBar: false,
        //     closeOnClick: true,
        //     pauseOnHover: true,
        //     draggable: true,
        //     progress: undefined,
        //     className: 'toast-message'
        //     });
        //     setTimeout(() => {
        //       setcurrentPage(pageNo);
        //       getUsers();
        //     }, 1000);
        //  }
      
         })
      
         }   

         //SelectParticular

         function SelectParticular(Id){

          const body =
            {
              
             id:Id
            }
            console.log('body',body);
      
          
            axios({
                   method:"POST",
                   url :`${BASE_URL}/Oat/Getparticularid`,
                   data:body, 
                   headers: {
                        "Content-type": "application/json",
                        "Authorization": "Bearer " + `${token}`,
                    }     
                }) 
                
           
                .then((response) =>{
                  console.log(response.data);
             
               
                  setEditoat(response.data)
                        
                  localStorage.setItem("EditData",JSON.stringify(response.data))
                  
               })
               .catch(error => {
                 console.log(error);
                 
               })
         }
     
         //  deletestatus


    

         function ConfirmDelete(Id){
             

            SelectParticular(Id)
           document.getElementById("modaldeleteForm").style.display = "block";

          

         }

         function DeleteStatus(Id,UserName){
  
         //confirm delete

      
          const body ={
           id: Id
         }
          console.log(body)
           axios({
          
           method:"POST",
          url:`${BASE_URL}/Oat/DeleteStatus`,
          data:body,
          headers: {
          "Content-Type" : "application/json",

          "Authorization": "Bearer " + `${token}`,
       
          }
         
           })
           .then((response) =>{
           console.log(response.data);

           closeForm();
        
          //  toast.info(  "Deleted"+" " + UserName +  "!", {
          //   position: "top-center",
          //   autoClose: 3200,
          //   hideProgressBar: false,
          //   closeOnClick: true,
          //   pauseOnHover: true,
          //   draggable: true,
          //   progress: undefined,
          //   className: 'toast-message'
          //   });
          setcurrentPage(1)

          document.getElementById("DelSuccess-Oat").style.display="block"
          getUsers()
          setTimeout(() => {
              document.getElementById("DelSuccess-Oat").style.display="none"
             
            }, 3000);
          
          
           })
        
              
       
          }



          //function edit

          const [Editoat, setEditoat] =useState([])

          function editoat(Id){

         


            SelectParticular(Id)


           
            setTimeout(() => {
              window.location.href="/?#/OatEditpop"
             // window.location.reload()
              
            }, 1000);

           setTimeout(() => {
             // window.location.href="/?#/Editpop"
              //window.location.reload()
              
            }, 2000);
        
      
          }

            //Genarete Password

        
          // const [SPassword,setPassword]=useState(0)
       

        //  const handlePassword=()=>{
           
        //    setPassword(Pass());
          
        //  }
         
         
  //              function ChangePassword(){

  //                      var Security = document.getElementById("Gpassword").value
  //                    const body ={currentPassword: Security, newPassword:SPassword}
  //             let bearer = 'Bearer ' + JSON.parse(localStorage.getItem('usertoken'));

  //                 axios({
  //                      method: "POST",
  //                      url :`${BASE_URL}/Oat/Generatepassword`,
  //                       data:body, 
  //                       headers: {
  //                        "Content-Type": "application/json",
  //                       'Authorization':bearer 
  //                       }     
  //                       }) 
  //                       .then((response) =>{
  //                         console.log(response.data);
                        
                        
  //                        if(response.data.status === "Error"){
                             
  //                             toast.error("InCorrect Password")
  //                           }
                        
  //                           else if(response.data.status === "Success"){
                        
  //                             toast.success("Password Change Successfully!", {
  //                               position: "top-center",
  //                               autoClose: 3200,
  //                               hideProgressBar: false,
  //                               closeOnClick: true,
  //                               pauseOnHover: true,
  //                               draggable: true,
  //                               progress: undefined,
  //                               className: 'toast-message'
  //                               });
  //                               setTimeout(() => {
                                  
  //                                 window.location.href="/#/"
  //                               }, 5000);
                             
                             
                        
  //                           }
  //                         })
  //                         .catch(error => {
  //                           console.log(error);
  //                         //  alert("failed !")
  //                         toast.error("Old Password is Incorrect")   
  //                         })
    
  //  }


      //    function GeneratePassword() {
      //      document.getElementById("Gpass").innerHTML=Pass();

      //       setPassword(Pass());

      //       ChangePassword()

      //    }
        
      //  function Pass(){
           
      //    var pass = '';
      //    var str = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ' +
      //            'abcdefghijklmnopqrstuvwxyz' +'0123456789' +'@#$';
           
      //    for (let i = 1; i <= 8; i++) {
      //        var char = Math.floor(Math.random()
      //                    * str.length + 1);
               
      //        pass += str.charAt(char)
      //    }
           
      //    return pass;

      //      }

           //activestatus usestate


          // const handleActive=()=>{
          //   setActive(1);
          // }

         

          // const handleInActive=()=>{
          //   setInActive(0);
          // }
          // const [Active, setActive] =useState(0)
          // const [InActive, setInActive] =useState(1)



      
          ///function update

          // function updateoat(Id,ActiveState){
           
         
          //   if(ActiveState==0){

          //     var Action =Active
          //    }
          //    else{
          //     var Action=InActive
 
          //    }
            
            // if(SPassword!=0){
                
            //   var SecurityPass = SPassword
            // }
            // else{
            //   var SecurityPass = Security

            // }
              
            // var Gpass = document.getElementById("Gpass").value;
          //   var EditName = document.getElementById("EditName").value;


          //   if(!EditName){
          //   document.getElementById("ErrA").innerHTML="UserName Required"

          //   }
          //   else if(EditName){

          //     document.getElementById("ErrA").innerHTML=" "

          //     const body =
          //     {
                
          //       userName:EditName, 
          //       id:Id,
          //       active:Action,
               
             
          //     }
          //     console.log('body',body);
        
            
          //     axios({
          //            method:"POST",
          //            url :`${BASE_URL}/Oat/UpdateAspNetUser`,
          //            data:body, 
          //            headers: {
          //                 "Content-type": "application/json",
          //                 "Authorization": "Bearer " + `${token}`,
          //             }     
          //         }) 
          
          //        .then((response) =>{
          //        console.log(response.data);
            
            
          //        if(response.data.status === "Success"){
                 
          //             toast.success("Updated")
                    
          //             getUsers()
        
          //             closeForm()
                           
                      

          //             //  setActive(false)

          //             // setInActive(false)
          //             setTimeout(() => {
          //             // window.location.reload()
          //             }, 3000);
          //           }
            
          //     })
          //     .catch(error => {
          //       console.log(error);
          //     //  alert("failed !")
          //     toast.warning("failed to Update")   
          //     })
                

          //   }
            

          // }

          //function closeform

          function closeForm(){

            document.getElementById("modaldeleteForm").style.display ="None"

          }

        
          
  return (
      
    <>
    
    <div className='oat-addmain'>
      
    <ToastContainer id="toast"
          position="top-center"
          autoClose={1500}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          /> 
       
    <div className="oat-addgrid-layout">
    
  <div className="oat-addmain-top">
    <div className='oat-addmain-back'>
    
    </div> 
    <span className='OatTitle'>
    <span> USERS</span></span>
    <div className='oat-addmain-back'>
      <Link to="/OAT"><i class="fa fa-angle-double-left" aria-hidden="true" id="tecbackicon"></i><br></br><span>Back</span></Link>
      </div> 
   
    </div>
    </div>

   {/* Alert Messages */}
   {/* Register success */}
    
    <div className='oat-toastpop-fade' id="RegSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Registered successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
 {/* Delete success */}
    
 <div className='oat-toastpop-fade' id="DelSuccess-Oat">
      <div className="modal-dialog" role="document" style={{marginTop:"140px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-success Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-check"></i></div>
    <strong style={{color:"#2b704a"}}>Success</strong>&nbsp;Deleted successfully!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="SuccessGif-Oat" src={Success} alt="success"/> */}
</div>
</div>
{/* Email Exist Toast */}

<div className='oat-toastpop-fade' id="EmailExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;Email Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>

{/* Name Exist Toast */}

<div className='oat-toastpop-fade' id="NameExist-Oat" style={{left:"3%"}}>
      <div className="modal-dialog" role="document" style={{marginTop:"110px"}}>
    <div class='OatAlert-content'>
<div class="Oatalert Oatalert-danger Oatalert-white rounded">
    <button type="button" class="OatAlertclose" data-dismiss="alert" aria-hidden="true" ></button>
    <div class="OatAlerticon"><i class="fa fa-times-circle"></i></div>
    <strong style={{color:"red"}}>Error</strong>&nbsp;Name Already Exist!  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
</div>
</div>



{/* <img id="ErrorGif-Oat" src={Error} alt="success"/> */}
</div>
</div>

    <div id="OatButton" style={{marginRight:"28px"}}>
    <div className='oat-addmain-add'>
      <button className='add-user' onClick={openAddForm}>  <i className="fa fa-user-o"></i>&nbsp;&nbsp;Add User</button>
    </div>
    <div className='oat-addmain-add'>
    <Link to="/OatAddRole"><button className='add-user'>  <i className="fa fa-address-book-o"></i>&nbsp;&nbsp;Add Role</button></Link>
    </div></div>
    <div className="oat-pop-fade" id="modalRegisterForm" tabindex="-1" role="dialog">
  <div className="modal-dialog" role="document">
    <div className="modal-content" style={{marginTop:"140px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">ADD USER</h4>
        <button type="button" className="close" onClick={closeAddForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form onSubmit={handleSubmit} id="oatform" >
      <div className="modal-body mx-3">
        <div className="md-form mb-5">

          <input type="text"  className="form-control validate"  placeholder='UserName' onKeyUp={handlechange} id="username" />
          <span id="nameErr" className='error'></span>
          <span id="nameErrA" className='error'></span>

        </div> 
        <div className="md-form mb-5">
          
          <input type="email" className="form-control validate" placeholder='Email' onKeyUp={handlechange} id="email" />
          <span id="mailErr" className='error'></span>
          <span id="mailErrA" className='error'></span>
        </div>

        <div className="md-form mb-5">
      
      <div style={{display:"flex"}}>
          <input  type="password"  className="form-control validate" placeholder='Password' onKeyUp={handlechange}  id="password" />
          <span className='oat-adduser-eyeicon'> <i class="fa fa-eye-slash" aria-hidden="true" onClick={hide} id="eye"></i></span>
          </div>
        
          <span id="passErr" className='error'></span>
          <span id="passErrA" className='error'></span>
     
        </div>
        <div className="md-form mb-4">
        <select  name="role"  className="form-select" onInputCapture={handlechange} id="roleid">
      <option value="">Role</option>
      {/* <option value="02">Team</option> */}
      {Roletable.map((e)=>
            {
              return<option value={e.role}>{e.role}</option>})}
     </select>
     <span id="roleErr" className='error'></span>
    
      
    </div>
      </div>
      <div className="modal-footer d-flex justify-content-center">
        <button className='oat-adduser-button' type="submit">Submit</button>
      </div>
      </form>
    </div>
  </div>
</div>
{
  allusers.length==0 ? (<div id="OatApiFail">" No Data Found "</div>):(
<div>
{/* </div>)}  */}
 <div className='oattable'>

  <div class="oat-table_responsive">


  <table> 
    <thead>
   <tr>
<th>Username</th>
<th>Email</th>
<th>Action</th>

</tr>
</thead>
<tbody>
{paginatedPosts.map((e,index) => {
      return<tr key={index}>

           <td>{e.userName}</td>
           <td>{e.email}</td>

           <td style={{whiteSpace:"nowrap"}}> 
            {/* {e.active==1 ?<button id ='oatActive-buttonA' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>Active</button>:
              <button id ='oatInActive-buttonB' onClick={()=>ActiveStatus(e.id,e.active,e.userName)}>InActive</button>} &nbsp;&nbsp; */}
             
              <span><i class="fa fa-pencil" aria-hidden="true"  onClick={()=>editoat(e.id,e.active,e.userName)} id="OatEditicon"></i></span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
             <span><i class="fa fa-trash" aria-hidden="true" onClick={()=>ConfirmDelete(e.id,e.UserName)} id="OatDelicon"></i></span>
              
              </td>
      </tr>
      })}
</tbody>

</table>



</div>

    </div>
    <br></br>
    {pageCount==1?null:<nav id="oatpagenav" style={{marginTop:"30px"}}>
    <ul className='pagination'>
      {/* {
        pages.map((page)=>(
          <li className={
            page === currentPage ? "page-item active" : "page-item"
          }>
            <p className='oatpage-link'
            onClick={()=>pagination(page)}
            >
            {page}
            </p>
            </li>
        ))
      } */}
        {currentPage >1?<li className="page-item">
              <a class="oatpage-link" onClick={onPrevious} aria-label="Next">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
              </a>
            </li>:null}
            &nbsp; &nbsp;
            <span style={{marginTop:"6px"}}>
         Page {currentPage} Of {pageCount} 
         
            </span>   &nbsp; &nbsp;
        {currentPage<pageCount?<li className="page-item">
              <a class="oatpage-link" onClick={onNext} aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
              </a>
            </li>:null}

    </ul>
  </nav>}
  </div>)} 
    {/* EditPopup */}

{/* <div className='oat-pop-fade' id="DisplayEditPop">
{Editoat.map((e)=>{
   return<div className="modal-dialog" role="document">
    <div className="modal-content">
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">EDIT USER</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <form  id="editoatform" onSubmit={()=>updateoat(e.id,e.active)}>
      <div className="modal-body mx-3">
        <div className="md-form mb-5">
       
          <input type="text" id="EditName"  defaultValue={e.userName} />
          <span id="ErrA" className='error'></span>
        </div> 
        <div className="md-form mb-5">

          <input type="text" defaultValue={e.email} readOnly/>

          </div>
        <div className="md-form mb-5">
       <input  value={e.passwordHash} id="Gpassword" />
          <span className='col-sm-7'  id="Generatebox" ><span id="Gpass"onChange={handlePassword}>Password</span></span> 
         <button id="Generatebtn" className='col-sm-4' type='button' onClick={GeneratePassword} >Generate</button>
    
         </div>
        
      
<div className="md-form mb-3">


{e.active==1 ? 

<center>
<input type="checkbox" id="oatinactiveswitch"
         class="InActivecheckbox"  onChange={()=>handleInActive(e.active)} />
<label for="oatinactiveswitch" className="toggleinactive">
  

<p className='InActiveLable'>Active&nbsp; &nbsp;&nbsp;Inactive</p>


</label>

</center>:
 


 <center>
 <input type="checkbox" id="oatactiveswitch"
              className="Activecheckbox"   onChange={()=>handleActive(e.active)}/>
  <label for="oatactiveswitch" className="toggleactive">
       

<p className='ActiveLable'>Active &nbsp;&nbsp;&nbsp;Inactive</p>


  </label>

  </center>


     }



</div>
       
      </div>
      <div className="modal-footer d-flex justify-content-center" id="editpopfooter">
        <button type="submit">Save Changes</button>
      </div>
      </form>
    </div>
  </div>})}

</div> */}

    {/* DeletePopup */}

   {Editoat.map((e)=>{ 
   return<div className="oat-pop-fade" id="modaldeleteForm" tabindex="-1" role="dialog">
     <div className="modal-dialog" role="document">
      <div className="modal-content" style={{marginTop:"240px"}}>
      <div className="modal-header text-center">
        <h4 className="modal-title w-100 font-weight-bold">! Warning</h4>
        <button type="button" className="close" onClick={closeForm}>
          <span aria-hidden="true">&times;</span>
        </button>
      </div>

    <form id='form'>

     <div className="modal-body mx-3">

        <div className="md-form mb-4">
            <div className='text-center'>
          <h5 style={{marginTop:"25px"}}>Are you sure want to Delete <span>{e.userName}</span> ?</h5>
          </div>
        </div>

      </div>

       <div className="modal-footer d-flex justify-content-center">
       <button className="oat-adduser-button" onClick={()=>DeleteStatus(e.id,e.userName)} type='submit'>Delete</button>
        <button className="oat-adduser-button" onClick={closeForm} type='submit'>Cancel</button>
       </div>

       </form>
      
     </div>
    </div>
</div>})}
    
    </div>
    </>
  )
}

export default Oataddusermain
